if($('.tiny-mce-textarea').length > 0){

    var editor_config = {
        selector: ".tiny-mce-textarea",
        plugins: [
            "advlist autolink lists link image media charmap autoresize print preview hr anchor pagebreak",
            "searchreplace visualblocks visualchars code fullscreen",
            "insertdatetime nonbreaking save table contextmenu directionality",
            "emoticons template paste textcolor colorpicker textpattern",
            "charcount"
        ],
        branding: false,
        autoresize_overflow_padding: 10,
        path_absolute : "/",
        forced_root_block : '',
        skin_url: false,
        skin: false,
        charCountLeft: false,
        setup: function (editor) {
            editor.on('init', function (e) {
                var editorContent = editor.getContent();
                if (editorContent == '' || $(this.formElement).hasClass('confirm-leqaving-form')){
                    editor.execCommand('mceInsertContent',false,'');
                    $('html, body').scrollTop(0);
                    $('form input').focus().focusout().blur();
                }
            });
        },
        toolbar: "undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link media image | forecolor",
        relative_urls: false,


    };



    //Char count plugin
    tinymce.PluginManager.add('charcount', function(editor) {



        editor.on('init', function() {
            editor.charCountLeft = $(this.getElement()).data('limit');
            function getCharacterLength() {
                var text = editor.getContent({format: 'text'});
                // trim and transform newlines ("\n" has a length of 2) to spaces (length = 1)
                text = text.trim().replace(/(\n)+/g, " ");
                if(editor.charCountLeft){
                    return editor.charCountLeft - text.length;
                } else{
                    return text.length;
                }
            }

            function update() {
                editor.theme.panel.find('#charcount').text(['Characters: {0}', getCharacterLength()]);
            }

            var statusbar = editor.theme.panel && editor.theme.panel.find('#statusbar')[0];
            if (statusbar) {
                window.setTimeout(function() {
                    statusbar.insert({
                        type: 'label',
                        name: 'charcount',
                        text: ['Characters: {0}', getCharacterLength()],
                        classes: 'wordcount',
                        disabled: editor.settings.readonly
                    }, 0);

                    editor.on('keyup setcontent beforeaddundo', function(){
                        update();
                    });

                }, 0);
            }

        });

    });

    tinymce.init(editor_config);
}




// WEBPACK FOOTER //
// ./resources/assets/themes/default/js/tinymce-init.js